import { Filmomtale } from "@filmweb/sanity-types";
import PublicRuntimeConfig from "lib/types/PublicRuntimeConfig";
import getConfig from "next/config";

const { serverRuntimeConfig, publicRuntimeConfig } = getConfig() as { serverRuntimeConfig: any; publicRuntimeConfig: PublicRuntimeConfig };
const isCinemaKinoklubb = (publicRuntimeConfig.NEXT_PUBLIC_IS_KINOKLUBB) === "true" || (serverRuntimeConfig.IS_KINOKLUBB === "true");

export default function isKinoklubb(filmomtale: Filmomtale): boolean {
	return isCinemaKinoklubb && filmomtale.isKinoklubb;
}